// extracted by mini-css-extract-plugin
export default {"title":"Blog_title__OAbot","subTitle":"Blog_subTitle__MaQqu","sec1":"Blog_sec1__iP+Q3","button":"Blog_button__0At3a"};